// extracted by mini-css-extract-plugin
module.exports = {"root":"Tag_root__nfRdl","lavender":"Tag_lavender__X2LqA","papaya":"Tag_papaya__SVsDm","chartreuse":"Tag_chartreuse__HX9F6","gray":"Tag_gray__yqXhN"};